import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import Seta from 'assets/images/seta.svg';
import { ProportionalSaleState } from 'store/modules/proportional_sale_simulation_store/types';
import CheckoutCard from 'components/atoms/checkout_card';
import SummaryBuy from 'components/atoms/summary_buy';
import SubscriptionPayment from '../subscription_payment';

interface CheckoutSaleRegisterProps {
  typeClient: string;
}

const CheckoutSaleRegister = (props: CheckoutSaleRegisterProps) => {
  const { typeClient } = props;

  const { simulate_register } = useSelector<ApplicationState, ProportionalSaleState>(
    (state) => state.session.proportional_sale,
  );

  return (
    <div className="container p-4 mt-5">
      <div className="row mt-3">
        <div className="col-12 col-md-8">
          {typeClient === 'beginner' && (
            <a href="/cadastrar">
              <img className="mr-2" src={Seta} alt="seta" /> Voltar
            </a>
          )}
          <h2>Assinatura</h2>
          <CheckoutCard
            serviceName={
              typeClient === 'was_subscribe'
                ? 'Plano Premium'
                : 'Introdução ao mundo das licitações'
            }
            serviceDescription={
              typeClient === 'was_subscribe'
                ? 'Assinatura Premium'
                : 'Treinamento + Oportunidades + Suporte Jurídico'
            }
            namePlan={simulate_register?.servicos[0]?.plano}
            valuePlan={simulate_register?.valor_final}
            baseValue={simulate_register?.valor_final}
            finalValue={
              simulate_register.payment === 'cartao'
                ? simulate_register?.valor_total_cartao
                : simulate_register?.valor_total_cartao
            }
            parcela={5}
            text=""
          />
        </div>
        <div className="col-12 col-md-4">
          <SummaryBuy
            serviceName={
              typeClient === 'was_subscribe'
                ? 'Plano Premium'
                : 'Introdução ao mundo das licitações'
            }
            finalValue={
              simulate_register.payment === 'cartao'
                ? simulate_register?.valor_total_cartao
                : simulate_register?.valor_final
            }
            baseValue={
              simulate_register.payment === 'cartao'
                ? simulate_register?.valor_base
                : simulate_register?.valor_base
            }
            variationValue={simulate_register?.valor_variacao_forma_pagamento}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8 mt-5">
          <h2>Pagamentos</h2>
          <SubscriptionPayment
            finalValue={
              simulate_register.payment === 'cartao'
                ? simulate_register?.valor_total_cartao
                : simulate_register?.valor_final
            }
            baseValue={
              simulate_register.payment === 'cartao'
                ? simulate_register?.valor_total_cartao
                : simulate_register?.valor_base
            }
            additionalValue={simulate_register?.valor_adicional}
            tradingValue={simulate_register?.valor_negociacao}
            variationValue={simulate_register?.valor_variacao_forma_pagamento}
            parcel={
              simulate_register.payment === 'cartao'
                ? simulate_register?.parcelas_cartao
                : simulate_register?.parcelas_boleto
            }
            services={[]}
            plan_id={5}
            update_client_register
            proportional={false}
            list_services={simulate_register?.servicos}
            type_sale="register"
          />
        </div>
        <div className="col-12 col-md-4 mt-5" />
      </div>
    </div>
  );
};
export default CheckoutSaleRegister;
